import React, { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

// Importing images
import singleImg03 from "../assets/AyurvedaAssets/images/single-img-03.jpg";
import icon07 from "../assets/AyurvedaAssets/images/icon-07.png";
import colBgImg4 from "../assets/AyurvedaAssets/images/bg-image/col-bgimage-4.jpg";
import faqImg from "../assets/AyurvedaAssets/images/bg-image/col-bgimage-4.jpg";

import TeamListing from "./Components/TeamListing";

export default function About() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  const [activeIndex, setActiveIndex] = useState(1);

  const faqs = [
    {
      question: "How does ayurveda work?",
      answer:
        "Ayurveda works by the assessing of an individual's unique constitution and using the natural remedies, diet, and lifestyle adjustments to restore balance.",
    },
    {
      question: "What are the three doshas in ayurveda?",
      answer:
        "Ayurveda categorizes individuals into three the doshas and they are the vata, pitta, and kapha, each representing different elemental energies in the body.",
    },
    {
      question: "What conditions can ayurveda treat?",
      answer:
        "Ayurveda can address the various health issues by including the digestive problems, stress, skin disorders, and chronic diseases, by addressing the root causes.",
    },
    {
      question: "Is the ayurvedic treatment safe?",
      answer:
        "When administered by trained professionals, ayurvedic treatments are generally safe. however, consult with an ayurvedic practitioner for personalized guidance.",
    },
    {
      question: "What is panchakarma in ayurveda?",
      answer:
        "Panchakarma is a detoxification and rejuvenation therapy in the ayurveda that involves the cleansing and eliminating the toxins from the body.",
    },
    {
      question: "Are ayurvedic herbs safe to use?",
      answer:
        "Ayurvedic herbs are generally the safe when used under the great expert guidance. self-prescribing herbs may lead to adverse effects, so consult an ayurvedic practitioner.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* page-title */}
      <div className="prt-page-title-row style5">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center about-form-timing">
              <div className="col-xl-6 col-lg-8 col-md-10 col-sm-9 ms-auto">
                <div className="prt-schedule">
                  <div className="prt-schedule-title">
                    <h2>Opening hours Trial</h2>
                    <p>Just make an appointment &amp; you're done!</p>
                  </div>
                  <div className="row mt-40 res-575-mt-20">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="prt-schedule-block">
                        <h3>Monday to Thursday</h3>
                        <p>9.30 am – 6.30 pm</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="prt-schedule-block">
                        <h3>Friday to Sunday</h3>
                        <p>11.00 am – 5.00 pm</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-10">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-whitecolor"
                      href="contact-us.html"
                    >
                      Make a appointment
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* page-title end */}

      {/* site-main start */}
      <div className="site-main">
        {/* about-section */}
        <section
          className="prt-row about-section01 clearfix"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="container">
            <div className="row row-equal-height">
              {/* col-bg-img-one */}
              <div className="col-xl-4 col-lg-6 col-md-12">
                <div className="col-bg-img-one prt-bg prt-col-bgimage-yes bg-base-darkblack spacing-1 border-rad_10">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer border-rad_10">
                    <div className="prt-col-wrapper-bg-layer-inner border-rad_10"></div>
                  </div>
                  <div className="layer-content">
                    <div className="prt-about-block1">
                      <h3>
                        Exploring the wellness through the{" "}
                        <span className="text-base-skin">ayurvedic</span>{" "}
                        solutions
                      </h3>
                    </div>
                    <ul className="prt-list prt-list-style-icon-02 mt-30 res-991-mt-15">
                      <li className="prt-list-li-content">
                        Customized wellness plans
                      </li>
                      <li className="prt-list-li-content">
                        Holistic lifestyle integration
                      </li>
                      <li className="prt-list-li-content">
                        Education and empowerment
                      </li>
                    </ul>
                    <div className="mt-40">
                      <a
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-whitecolor w-100"
                        href="#"
                      >
                        Explore our solutions
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* col-bg-img-one end */}

              {/* col-bg-img-two */}
              <div className="col-xl-4 col-lg-6 col-md-12">
                <div className="col-bg-img-two prt-bg prt-col-bgimage-yes bg-base-dark spacing-1 border-rad_10 res-991-mt-30">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer border-rad_10">
                    <div className="prt-col-wrapper-bg-layer-inner border-rad_10"></div>
                  </div>
                  <div className="layer-content text-start">
                    <div className="prt-about-block1">
                      <h3>
                        Discover our various ayurvedic essence with your path to
                        wellness begins here
                      </h3>
                    </div>
                    <div className="mt-20a">
                      <a
                        className="prt-btn btn-inline prt-btn-color-whitecolor btn-underline"
                        href="#"
                      >
                        View more
                      </a>
                    </div>
                    <div className="row mt-80 res-991-mt-40">
                      <div className="col-lg-6 col-md-4 col-sm-5">
                        <div className="prt-fid inside style1">
                          <div className="prt-fid-contents">
                            <h4 className="prt-fid-inner">
                              <span
                                data-appear-animation="animateDigits"
                                data-from="0"
                                data-to="25"
                                data-interval="1"
                              >
                                37
                              </span>
                              <span>+</span>
                            </h4>
                            <div className="fid-contents">
                              <h3 className="prt-fid-title">
                                years of experience — Doctors & Vedacharya
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-8 col-sm-7">
                        <div className="prt-fid inside style1 res-575-mt-20">
                          <div className="prt-fid-contents">
                            <h3 className="prt-fid-inner">
                              <span
                                data-appear-animation="animateDigits"
                                data-from="0"
                                data-to="53"
                                data-interval="2"
                              >
                                Real results
                              </span>
                              <span>+*</span>
                            </h3>
                            <div className="fid-contents">
                              <h3 className="prt-fid-title">
                                Trusted by patients worldwide
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* col-bg-img-two end */}

              {/* featured-image-box */}
              <div className="col-xl-4 col-lg-6 col-md-12">
                <div className="featured-image-box res-1199-mt-30">
                  <div className="featured-thumbnail">
                    <img
                      width="413"
                      height="200"
                      className="img-fluid w-100"
                      src={singleImg03}
                      alt="image"
                    />
                  </div>
                  <div className="featured-content">
                    <div className="featured-title">
                      <h3>Our mission</h3>
                    </div>
                    <div className="featured-desc">
                      <p>
                        Our mission lays a commitment to bring the profound
                        benefits of ayurveda to people from all walks of life.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* featured-image-box end */}
            </div>
          </div>
        </section>
        {/* about-section end */}

        {/* padding_zero-section */}
        <section className="prt-row padding_zero-section pt-50 res-991-pt-0 clearfix">
          <div className="container">
            <div className="row g-0">
              <div className="col-lg-12">
                <div className="row g-0">
                  {/* Left Column */}
                  <div className="col-lg-6 col-md-12">
                    {/* col-bg-img-three */}
                    <div className="col-bg-img-three prt-bg prt-col-bgimage-yes bg-base-darkblack prt-left-span spacing-3">
                      <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                        <div className="prt-col-wrapper-bg-layer-inner"></div>
                      </div>
                      <div className="layer-content">
                        <div
                          className="prt-quotes-block"
                          data-aos="fade-right" // changed from fade-up
                          data-aos-duration="1000"
                        >
                          {/* featured-icon-box */}
                          <div className="featured-icon-box icon-align-before-content style3">
                            <div className="featured-icon">
                              <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                                <img
                                  width="56"
                                  height="44"
                                  src={icon07}
                                  className="img-fluid"
                                  alt="icon"
                                />
                              </div>
                            </div>
                            <div className="featured-content">
                              <div className="featured-title">
                                <h3>Bharat Dhara Team</h3>
                              </div>
                              <div className="featured-desc">
                                <p>Director, Bharat Dhara</p>
                              </div>
                            </div>
                          </div>
                          {/* featured-icon-box end */}

                          <div className="mt-15">
                            <h3>
                              We push the limits of{" "}
                              <span>what&apos;s possible</span> for our
                              patients.
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* col-bg-img-three end */}
                  </div>

                  {/* Right Column */}
                  <div className="col-lg-6 col-md-12">
                    <div className="prt-bg bg-base-grey prt-right-span spacing-2 position-relative">
                      <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                        <div className="prt-col-wrapper-bg-layer-inner"></div>
                      </div>
                      <div className="layer-content">
                        {/* section title */}
                        <div className="section-title">
                          <div className="title-header">
                            <h2 className="title quotes-title">
                              Welcome to Bharat Dhara care
                            </h2>
                          </div>
                          <div className="title-desc">
                            <p className="prt-about-desc">
                              Our clients are our priority, we offer quality
                              medical services with a team of specialists.
                            </p>
                            <p className="mt-30">
                              welcome to Bharat Dhara care, where ancient wisdom
                              meets modern healthcare. our mission is to nurture
                              your well-being through personalized{" "}
                              <u className="headingfont-color">
                                ayurvedic solutions.
                              </u>{" "}
                              with a team of experienced practitioners and a
                              commitment to holistic wellness, we provide
                              comprehensive healthcare services tailored to your
                              unique needs and we prioritize your health,
                              treating not just the symptoms but the root causes
                              of ailments.
                            </p>
                            <p className="mt-10">
                              Our state-of-the-art facilities and the
                              client-centered approach ensure you receive the
                              highest quality care. join us on a journey to
                              optimal health and balance. welcome to Bharat
                              Dhara care, your trusted partner in wellness.
                            </p>
                          </div>
                        </div>
                        {/* section title end*/}
                      </div>
                    </div>
                  </div>
                </div>
                {/* row end */}
              </div>
            </div>
          </div>
        </section>
        {/* padding_zero-section end */}

        <TeamListing />

        {/* faq-section (last image example) */}
        <section className="prt-row faq-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <img
                  className="img-fluid prt-equal-height-image w-100"
                  src={colBgImg4}
                  alt="bg"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="prt-row padding_zero-section bg-layer-equal-height faq-section spacing-5 z-index_1 position-relative clearfix">
          <div className="container">
            <div className="row">
              {/* FAQ Accordion */}
              <div className="col-lg-7 spacing-2">
                <h4>Frequently Asked Question's</h4>
                <div className="accordion style1">
                  {faqs.map((faq, index) => (
                    <div
                      key={index}
                      className={`toggle prt-toggle_style_classic prt-control-right-true ${
                        activeIndex === index ? "active" : ""
                      }`}
                    >
                      <div className="toggle-title">
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleFaq(index);
                          }}
                          className={activeIndex === index ? "active" : ""}
                        >
                          {faq.question}
                        </a>
                      </div>
                      <div
                        className={`toggle-content ${
                          activeIndex === index ? "show" : "d-none"
                        }`}
                      >
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Image Section */}
              <div className="col-lg-5">
                <div className="col-bg-img-four prt-bg prt-col-bgimage-yes bg-base-darkblack prt-right-span ml-45 res-1199-ml-0">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                    <div className="prt-col-wrapper-bg-layer-inner"></div>
                  </div>
                  <div className="layer-content"></div>
                </div>
                <img
                  className="img-fluid prt-equal-height-image w-100"
                  src={faqImg}
                  alt="bg-image"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-md-12">
                <div className="prt-info-main-block d-flex align-items-center flex-wrap">
                  {/* Info Button */}
                  <div className="info_btn mr-30 res-767-mb-15">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                      href="#"
                    >
                      COVID-19 resources
                    </a>
                  </div>

                  {/* Featured Icon Box */}
                  <div className="featured-icon-box icon-align-before-content style2">
                    <div className="featured-icon">
                      <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                        <i className="flaticon-alert"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>Get The Health package</h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          What you need to know about the 2019 - 2023 fly
                          season.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Featured Icon Box End */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* site-main end */}
    </>
  );
}
